import React from 'react'
import createMarkup from '@/shared-utils/create-markup'

function Footer({ footerHTML }: { footerHTML: string }) {
  const footerContent = (
    <div
      dangerouslySetInnerHTML={createMarkup(footerHTML)}
      id="pcln-global-footer"
    />
  )

  return footerHTML.length > 0 ? footerContent : null
}

export default Footer
